import * as helper from "./../../../Assets/Js/helper";
import * as Events from "./Events";
import Chatsim from "./ChatsimPlayer2";

export default class ChatsimDirector {
	constructor(cdnDomain) {
		this.Chatsim = new Chatsim(cdnDomain);
		this.PaytourHelper = window.paytourHelper;

		this.bodyState = "";
		this.events = {
			onAfterShow: function () {
				helper.hide(document.getElementById("hostMenu"));
				this.bodyState = window.document.body.style.overflow;
				window.document.body.style.overflow = "visible";
				let test = document.getElementById("aterra");
				if (test !== null) {
					document.body.appendChild(
						helper.stringToHtml(
							'<img id="aterra" alt="" src="//r.remarketingpixel.com/px.gif?akey=29c856a6c32a014a2c5d05553c9596fd" style="position: absolute; left: -10000px;" />'
						)
					);
				}
			}.bind(this),
			onAfterHide: function () {
				helper.show(document.getElementById("hostMenu"));
				window.document.body.style.overflow = this.bodyState;
			}.bind(this),
		};

		let signupButtons = document.querySelectorAll("#register, #bonusButton, #signup, .signup"),
			presentationModel = JSON.parse(helper.getData(helper.$("#modelContainer"), "presentationmodel")),
			isNoFullScreenVersion = [2, 10, 11, 12, 13].indexOf(presentationModel.version) === -1,
			maxWidth = isNoFullScreenVersion ? 1920 : 1215,
			clearChatOnEachStep = [14].indexOf(presentationModel.version) !== -1,
			isSafari = presentationModel.isSafariBrowser,
			options = {
				startCommand: presentationModel.startCommand,
				showCta: presentationModel.ctaClip,
				maxVideoWidth: maxWidth,
				mobile: presentationModel.mobile,
				signUpText: "Jetzt loslegen!",
				onSignup: [
					function () {
						for (let button of signupButtons) {
							helper.triggerEvent(button, "click", {});
						}
					},
				],
				onRegister: [
					function () {
						helper.triggerEvent(window, "register", {});
					},
				],
				clearCacheOnEachStep: clearChatOnEachStep,
				location: presentationModel.location !== null ? presentationModel.location : false,
				signupBtnHeight: isNoFullScreenVersion ? 50 : 0,
				btnContainer: isNoFullScreenVersion ? "#chat ul" : "#userMenu ul",
				version: isNoFullScreenVersion ? "noFullScreen" : "fullscreen",
				versionNumber: presentationModel.version,
				isSafari,
				onDialogChoice: [
					function () {
						helper.triggerEvent(document, "clickedButton");
					},
				],
			};

		if (presentationModel.pt === 0) {
			options.hideSignupConfirmation = true;
		}

		helper.addEventListener(
			window,
			"signUp",
			function () {
				if (presentationModel.pt === 0) {
					this.PaytourHelper.openSignup(options, this.events);
				} else {
					this.PaytourHelper.openPaytour(options, this.events);
				}
			}.bind(this)
		);

		options.playlist = presentationModel.selPlaylist;
		window.selHost = presentationModel.selHostId;

		let overlays = document.querySelectorAll("#overlay-mobile0, #overlay-mobile1, #overlay-mobile2");

		if (overlays.length > 0) {
			helper.addEventListener(
				document.getElementById("btn-overlay"),
				"click",
				function () {
					this.Chatsim.init(presentationModel.selPlaylist, options);
					helper.hideAll(overlays);
				}.bind(this)
			);

			// helper.addEventListener(document.getElementById('btn-overlay-exit'), 'click', function () {
			// 	window.location = 'https://www.bing.de/search?q=visit-x';
			// });
		} else {
			this.Chatsim.init(presentationModel.selPlaylist, options);
		}

		this.addMoreHostClickListener(options);
		let link = this.addGALinkDecorator(presentationModel);

		this.addVXPaytourClickListener(link, presentationModel);
		this.checkVersion(presentationModel);
	}

	addMoreHostClickListener() {
		let moreImages = document.querySelectorAll("#moar img");
		for (let image of moreImages) {
			helper.addEventListener(
				image,
				"click",
				function (evt) {
					let me = evt.currentTarget;
					let playlist = JSON.parse(helper.getData(me, "rel"));
					let plNum = helper.getData(me, "plnum");
					let id = parseInt(helper.getData(me, "id"));

					if (typeof _errs !== "undefined") {
						_errs.meta.actualHost = parseInt(playlist.chat.metainfo.senderid);
						_errs.meta.actualPlNum = parseInt(plNum);
					}

					window.selHost = id;
					helper.triggerEvent(window, Events.HOST_CHANGED);

					if (typeof window.paytour !== "undefined") {
						window.paytour.sendOptions({ s: id, host: id });
					}
					document.getElementById("hostPic").style.backgroundImage = "url(" + me.getAttribute("src") + ")";
					this.Chatsim.changePlaylist(playlist);
				}.bind(this)
			);
		}
	}

	checkVersion(presentationModel) {
		if (presentationModel.version === 11) {
			helper.removeAll(document.querySelectorAll("a#register span"));
		}
	}

	addVXPaytourClickListener(link, presentationModel) {
		let options = {
			targetUrl: link,
			host: presentationModel.selHostId,
			successUrl: decodeURIComponent(presentationModel.successURL),
			pfm: presentationModel.pfm,
			option: presentationModel.option,
			disableJump: true,
		};

		if (presentationModel.option !== "") {
			options.option = presentationModel.option;
		}

		let buttons = document.querySelectorAll(
			"#register, #bonusButton, #signup, .signup,  #exitIntentPopup img, #exitIntentPopup ul, #registerswitch"
		);

		for (let button of buttons) {
			helper.addEventListener(
				button,
				"click",
				function () {
					let selHost = window.selHost;
					if (typeof selHost !== "undefined") {
						options.host = parseInt(selHost);
					}
					if (presentationModel.pt === 0) {
						this.PaytourHelper.openSignup(options, this.events);
					} else {
						this.PaytourHelper.openPaytour(options, this.events);
					}
				}.bind(this)
			);
		}

		this.PaytourHelper.initPaytour(options, this.events);
		this.PaytourHelper.modalBox.hook("login", function () {
			document.body.appendChild(
				helper.stringToHtml(
					'<img alt="" src="//r.remarketingpixel.com/px.gif?akey=2229aed790fce6a76f67a1841b29c992" style="position: absolute; left: -10000px;" />'
				)
			);
		});
		this.PaytourHelper.modalBox.hook("signup", function () {
			document.body.appendChild(
				helper.stringToHtml(
					'<img alt="" src="//r.remarketingpixel.com/px.gif?akey=2229aed790fce6a76f67a1841b29c992" style="position: absolute; left: -10000px;" />'
				)
			);
		});
	}

	addGALinkDecorator(presentationModel) {
		let link = presentationModel.targetUrl;

		return link;
	}
}
